import React from 'react';

interface ReconnectingOverlayProps {
  connectionStatus: string;
}

const ReconnectingOverlay: React.FC<ReconnectingOverlayProps> = ({ connectionStatus }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-8 max-w-md mx-4 text-center">
        {/* Animated spinner */}
        <div className="flex justify-center mb-6">
          <div className="relative">
            <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-2xl">
              🔄
            </div>
          </div>
        </div>

        {/* Status message */}
        <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-3">
          Reconnecting...
        </h2>
        <p className="text-gray-600 dark:text-gray-300 text-lg">
          {connectionStatus}
        </p>

        {/* Helpful message */}
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-4">
          Your progress is saved. We'll restore your score when connection is re-established.
        </p>
      </div>
    </div>
  );
};

export default ReconnectingOverlay;
